<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <!--      <template slot="menuLeft">-->
      <!--        <el-button-->
      <!--          type="danger"-->
      <!--          size="small"-->
      <!--          icon="el-icon-delete"-->
      <!--          plain-->
      <!--          v-if="permission.inspectnode_delete"-->
      <!--          @click="handleDelete"-->
      <!--          >删 除-->
      <!--        </el-button>-->
      <!--      </template>-->
      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          icon="el-icon-error"
          v-if="permission.inspectnode_edit"
          @click="forbid(scope.row)"
          :hidden="hideForbidBtn(scope.row)"
          >禁用
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-circle-check"
          v-if="permission.inspectnode_edit"
          @click="start(scope.row)"
          :hidden="hideStartBtn(scope.row)"
          >启用
        </el-button>
      </template>
      <template slot-scope="scope" slot="propertyIdCopyForm">
        <div>
          <el-select
            @change="selectBasePropertyChange"
            v-model="form.propertyIdCopy"
            clearable
            filterable
          >
            <el-option
              v-for="item in basePropertyList"
              :key="item.id"
              :label="item.objectFullName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </template>
      <template slot-scope="scope" slot="equipmentIdForm">
        <div>
          <el-select ref="nodeFormRef" v-model="form.equipmentId" clearable filterable>
            <el-option
              v-for="item in equipmentList"
              :key="item.id"
              :label="item.equipmentName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  updateStatusForbid,
  updateStatusStart,
} from '@/api/v4ward/inspectnode/inspectnode';
import { mapGetters } from 'vuex';
import { getEquipmentTree } from '../../../api/v4ward/equipment/equipmentinfo';
import { getBasePropertyTree } from '../../../api/v4ward/inspectplan/inspectplan';

export default {
  data() {
    return {
      basePropertyList: [],
      equipmentList: [],
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 'auto',
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: true,
        editBtn: true,
        delBtn: true,
        selection: false,
        columnBtn: false,
        refreshBtn: false,
        searchLabelWidth: 100,
        labelWidth: 130,
        column: [
          {
            label: '所属小区',
            prop: 'propertyId',
            type: 'tree',
            dataType: 'string',
            dicUrl: 'api/base/property/treeChildrenPowerNode',
            props: { label: 'objectFullName', value: 'id' },
            search: true,
            editDisplay: false,
            addDisplay: false,
            viewDisplay: true,
            rules: [
              {
                required: true,
                message: '请选择所属小区',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '所属小区',
            prop: 'propertyIdCopy',
            hide: true,
            formslot: true,
            labelslot: true,
            errorslot: true,
            viewDisplay: false,
            rules: [
              {
                required: true,
                message: '请选择所属小区',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '巡检点名称',
            prop: 'nodeName',
            maxlength: 30,
            showWordLimit: true,
            search: true,
            rules: [
              {
                required: true,
                message: '请输入巡检点名称',
                trigger: 'blur',
              },
            ],
            searchPlaceholder: '模糊匹配巡检点名称',
          },
          {
            label: '巡检点编码',
            prop: 'nodeCode',
            maxlength: 30,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入巡检点编码',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '关联设备名',
            prop: 'equipmentName',
            maxlength: 30,
            showWordLimit: true,
            editDisplay: false,
            addDisplay: false,
            viewDisplay: true,
            search: true,
            searchPlaceholder: '模糊匹配设备名',
          },
          {
            label: '关联设备名',
            prop: 'equipmentId',
            formslot: true,
            labelslot: true,
            errorslot: true,
            hide: true,
            viewDisplay: false,
          },
          {
            label: '具体位置',
            prop: 'location',
            type: 'textarea',
            overHidden: true,
            span: 24,
            row: 4,
            maxlength: 200,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入具体位置',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '禁用状态',
            prop: 'disabledState',
            type: 'select',
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=checking_point_status',
            props: { label: 'dictValue', value: 'dictKey' },
            editDisplay: false,
            addDisplay: false,
            search: true,
          },
          // {
          //   label: 'X轴坐标（纬度）',
          //   prop: 'axisX',
          //   rules: [
          //     {
          //       required: true,
          //       message: '请输入X轴坐标（纬度）',
          //       trigger: 'change',
          //     },
          //   ],
          // },
          // {
          //   label: 'Y轴坐标（经度）',
          //   prop: 'axisY',
          //   rules: [
          //     {
          //       required: true,
          //       message: '请输入Y轴坐标（经度）',
          //       trigger: 'change',
          //     },
          //   ],
          // },
          {
            label: '备注',
            prop: 'remark',
            type: 'textarea',
            overHidden: true,
            span: 24,
            row: 4,
            maxlength: 200,
            showWordLimit: true,
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.inspectnode_add, false),
        viewBtn: this.vaildData(this.permission.inspectnode_view, false),
        delBtn: this.vaildData(this.permission.inspectnode_delete, false),
        editBtn: this.vaildData(this.permission.inspectnode_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  mounted() {
    this.initAllList();
  },
  methods: {
    initAllList() {
      getBasePropertyTree().then(({ data }) => {
        this.basePropertyList = data;
      });
    },
    selectBasePropertyChange(value) {
      this.form.equipmentId = '';
      getEquipmentTree(value).then(({ data }) => {
        this.equipmentList = data;
      });
    },
    hideStartBtn(row) {
      //    --》隐藏按钮
      return row.disabledState !== 2;
    },
    hideForbidBtn(row) {
      //    --》隐藏按钮
      return row.disabledState !== 1;
    },
    start(row) {
      this.$confirm('确定启用该巡检点?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          console.log(row);
          return updateStatusStart({ id: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    forbid(row) {
      this.$confirm('确定禁用该巡检点?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          console.log(row);
          return updateStatusForbid({ id: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    rowSave(row, loading, done) {
      console.log(row);
      row.propertyId = row.propertyIdCopy;
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      row.propertyId = row.propertyIdCopy;
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
          this.form.propertyIdCopy = data.propertyId;
          if (data.equipmentId === '0') {
            this.form.equipmentId = '';
          }
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
